/** Maps a camelCase (wire) or snake_case sales rep payload to the page's snake_case shape. */
export const mapSalesRep = (item) => ({
    id: item.id,
    sales_rep_id: item.salesRepId ?? item.sales_rep_id,
    name: item.name,
    email: item.email,
    phone_number: item.phone?.number ?? null,
    reports_to: item.reportsTo ?? item.reports_to ?? null,
    reports_to_name: (item.reportsToDetail ?? item.reports_to_detail)?.name ?? null,
    territory_id: item.territoryId ?? item.territory_id ?? null,
    is_active: !!(item.isActive ?? item.is_active),
    clinic_count: item.clinicCount ?? item.clinic_count ?? 0,
    created_at: item.createdAt ?? item.created_at,
});
export const mapSalesSummaryRow = (item) => {
    const salesRepId = item.salesRepId ?? item.sales_rep_id ?? null;
    const territoryId = item.territoryId ?? item.territory_id ?? null;
    const isUnassigned = !!(item.isUnassigned ?? item.is_unassigned);
    return {
        key: item.id ?? salesRepId ?? territoryId ?? 'unassigned',
        rep_uuid: item.id ?? null,
        label: isUnassigned ? 'Unassigned' : item.name ?? territoryId ?? '',
        sales_rep_id: salesRepId,
        territory_id: territoryId,
        is_unassigned: isUnassigned,
        order_count: item.orderCount ?? item.order_count ?? 0,
        gross_sales: item.grossSales ?? item.gross_sales ?? '0.00',
        discounts: item.discounts ?? '0.00',
        net_sales: item.netSales ?? item.net_sales ?? '0.00',
        total: item.total ?? '0.00',
    };
};
